<template>
  <li class="task" data-task-id="{!! $task->id !!}"
      :data-description="modifiedDescription">

    <i :class="this.task.priority === 0 ? 'red' : 'text-primary'" class="icon mdi mdi-phone-return"></i>
    <div class="info">
      <div class="description" :style="{ color: this.task.priority_color }">
        {{ this.task.content }}
      </div>
      <span class="subtext">
          <span class="label" :style="{ backgroundColor: getDateColor }">
                {{ task.formatted_date }}
          </span>
          <div class="flex-row " v-if="creator">
            <i class="mdi mdi-account m-auto"></i>
            {{ creator.fullname }}
          </div>
          <a :href="customer.link" class="flex-row p-0" v-if="customer">
              <i :class="customer.icon_string"></i>
            {{ customer.full_name }}
          </a>
      </span>
    </div>

    <div class="actions task-actions">
      <!-- TODO: check if user is allowed to update-task before render -->
      <a :href="editTaskUrl"
         class="btn btn-primary tooltip-toggle edit"
         data-toggle="tooltip" data-placement="top"
         title="Taak Bewerken"><i class="mdi mdi-pencil"></i></a>
      <button @click="completeTask" class="btn btn-success tooltip-toggle complete-task"
              data-placement="left"
              title="Terugbelverzoek markeren als voltooid"><i
        class="mdi mdi-check"></i></button>
    </div>
  </li>

</template>

<script>
import moment from "moment";
import task from "../../api/task";
import CallbackTask from "../../models/CallbackTask";

export default {
  name: "UserTaskComponent",
  emits: ["fetch-callbacks"],
  data() {
    return {};
  },
  computed: {
    loggedInUser() {
      return this.$store.state.user;
    },
    editTaskUrl() {
      if (this.task.customer_id) {
        return this.route('vue.task.edit', {customer: this.task.customer_id, task: this.task.id});
      }
      return "task/" + this.task.id + "/edit";
    },
    modifiedDescription() {
      if (this.task.description === null ) {
        return "";
      }
      return this.task.description.replace(/"/g, "&quot;");
    },
    getDateColor() {
      let taskDueDate = moment(this.task.date);
      let isLate = taskDueDate.isBefore(moment(), "day");
      if (isLate) {
        return "#ff0052";
      }
    },
    creator() {
      if (!this.task.creator) return;
      let creator = JSON.parse(JSON.stringify(this.task.creator));
      return creator.data;
    },
    customer() {
      if (!this.task.customer) return;
      let customer = JSON.parse(JSON.stringify(this.task.customer));
      return customer.data;
    }
  },
  methods: {
    moment,
    completeTask() {
      task
        .completeTask(this.task.id, this.loggedInUser.id)
        .finally(() => {
          this.$emit("fetch-callbacks");
        });
    }
  },
  props: {
    task: CallbackTask
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.label {
  background-color: $light-blue;
  color: white;
}

.red {
  color: #ff0052;
}

.task {
  color: $text-color;
  background-color: white;
  display: flex;
  gap: $spacing-sm;
  align-items: center;
  margin: 5px;
  padding: 17px 5px 22px;


  .icon {
    font-size: 50px;
  }

  .info {
    flex-grow: 1;
    flex-shrink: 1;
    display: grid;
    row-gap: $spacing-xs;

    .subtext {
      display: flex;
      flex-wrap: wrap;
      gap: $spacing-xs;

      .label {
        line-height: initial;
      }
    }
  }

  .actions {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
  }
}
</style>
